import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export class BridgeLogoutController extends BridgeComponent {
    static component = "logout"

    connect() {
        super.connect()
        if (this.bridgeElement.enabled) {
            this.send("connect", {}, () => this.bridgeElement.click())
        }
    }
}
